import cx from "classnames"
import { Loader } from "lucide-react"
import type { ReactNode } from "react"

interface RowWrapperProps {
    icon: ReactNode
    label: string
    statusIcon?: ReactNode | null
    headerInfo?: ReactNode | null
    isError?: boolean
    isPending?: boolean
    collapsible?: boolean
    expanded: boolean
    onToggle: () => void
    children: ReactNode
}

export function RowWrapper({ icon, label, statusIcon, headerInfo, isError, isPending, collapsible = true, expanded, onToggle, children }: RowWrapperProps) {
    const showContent = !collapsible || expanded

    if (isPending) {
        return (
            <div className="py-1">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 border border-border bg-base-200/50 px-3 py-1.5 text-sm text-muted">
                    <Loader size="1em" className="animate-spin" />
                    {icon}
                    <span className="font-medium">{label}</span>
                    {headerInfo}
                </div>
                {showContent && <div className="border-x border-b border-border">{children}</div>}
            </div>
        )
    }

    return (
        <div className="py-1">
            <div
                className={cx(
                    "flex flex-wrap items-center gap-x-2 gap-y-1 border border-border px-3 py-1.5 text-sm",
                    isError ? "bg-error/10" : "bg-base-200/50",
                    collapsible && (isError ? "cursor-pointer hover:bg-error/20" : "cursor-pointer hover:bg-base-300")
                )}
                onClick={collapsible ? onToggle : undefined}
            >
                {statusIcon}
                {icon}
                <span className={cx("font-medium", isError ? "text-error" : "text-base-content")}>{label}</span>
                {headerInfo}
            </div>
            {showContent && <div className="border-x border-b border-border">{children}</div>}
        </div>
    )
}
